export default "__VITE_ASSET__GYNP6bvh__"